<template>
    <b-modal id="modal-load-results" centered hide-footer no-close-on-backdrop :body-class="'px-4 pb-4 pt-3'"
        no-close-on-esc>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ $t('loadResults.title') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="d-block">
            <b-row>
                <b-col sm="12">
                    <div class="text-area-results p-3">
                        <pre>{{ results }}</pre>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="text-right modal-footer border-0 p-0 mt-3">
            <b-button class="mx-0 h-40px w-100px" variant="secondary"
                @click="$bvModal.hide('modal-load-results')">{{ $t('loadResults.close') }}</b-button>
        </div>
    </b-modal>
</template>
<script>
export default {
    name: "LoadResults",
    props: ['results'],
    data() {
        return {

        };
    },
};
</script>
<style scoped>
.text-area-results {
    background-color: #fafafa !important;
    font-size: 14px;
    height: 400px;
    overflow-y: auto;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
}
</style>
